import React, { useEffect, useRef } from 'react';

export default function Modal({ title, onClose, children, footer, maxWidth }) {
  const modalRef = useRef(null);

  // Focus the modal on open — once, and only once.
  //
  // This used to live in the Escape-key effect below, which re-runs whenever
  // onClose changes identity. Callers write `onClose={() => setEditing(false)}`,
  // a fresh arrow on every parent render, and a controlled input inside the
  // modal re-renders its parent on every keystroke. So each character typed
  // re-ran the effect and pulled focus out of the field and back onto the modal
  // shell: you got one letter, then had to click back in for the next.
  useEffect(() => {
    if (modalRef.current) modalRef.current.focus();
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal"
        style={maxWidth ? { maxWidth } : undefined}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        ref={modalRef}
        tabIndex={-1}
      >
        <div className="modal-header">
          <h2 id="modal-title">{title}</h2>
          <button onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
